/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import {Card, CardBody, Col, Button, Form, FormGroup, Label, CardHeader} from 'reactstrap';
import {Spring} from 'react-spring'
import {TimingAnimation, Easing} from 'react-spring/dist/addons'
import { Link, Redirect } from "react-router-dom";

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
import LanguageManager from '../../custom-classes/language-manager';
/** End of Multiple Language imports **/

import FormGroupUsername from './form-group-username';
import FormGroupNewPassword from './form-group-new-password';
import FormGroupName from './form-group-name';
import ModalGeneric from '../modals/modal-generic';
import ModalAddAnotherProfile from '../modals/modal-add-another-profile'
import SelectorSex from '../selectors/selector-sex';
import DatePicker from '../date-picker/date-picker';
import moment from 'moment';
import ApiCalls from '../../custom-classes/api-calls';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import SelectorSubscriptions from '../selectors/selector-subscriptions';

/**
 * The form to register new users
 */
class FormProfileRegister extends React.Component {

    constructor(props) { // start with a constructor if we want to do modifications on events
        super(props); // Super is required.

        // Declare the properties and set the value according to what we are going to manage in the the page
        this.state = {
            firstName: '',
            lastName: '',
            password: '',
            passwordRetype: '',
            username: '',
            dob: null,
            sex: '',
            validPassword: false,
            usernameAvailable: true,
            validUsername: false,
            validFirstName: false,
            validLastName: false,
            propsModal: null,
            propsModalAddNewProfile: null,
            showErrorModal: false,
            createdAt: moment(),
            calendarFocused: false,
            proceedSubmit: false,
            subscriptionId: this.props.data.subscriptionId,
            showAddNewProfileModal: false, // Shows the modal to add a new user right now
            cameFromRegister: this.props.data.cameFromRegister, // If came from register to follow the register steps
            transactionSuccess: false,
            goToDashboard: false,
            goToDownload: false
        };

        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en")}
        });
        this.props.addTranslation(global);

        this.setSubmitButtonState = this.setSubmitButtonState.bind(this);
        this.submitRegister = this.submitRegister.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.setSelectedSubscription = this.setSelectedSubscription.bind(this);
        this.toogleAlertAddNewProfile = this.toogleAlertAddNewProfile.bind(this);

    }

    setSelectedSubscription = (field) => (newValue) => {
        this.setState({
            'subscriptionId': newValue
        }, () => {
            this.setSubmitButtonState();
        });
    };

    /**
     * Toggles alert modal (alert from registration)
     */
    toggleAlertModal() {
        this.setState({showErrorModal: false},()=>{
            if(this.state.transactionSuccess && this.state.cameFromRegister)
            {
                this.setState({goToDownload: true},()=>{
                    this.props.updateParent(this.state);
                    return this.state;
                })
            }
        });
    }

    /** Toggles the alert modal, and according to the response, it sends it to the whatever it needs to be sent **/
    toogleAlertAddNewProfile(data){
        console.log("Toggling");
        this.setState({showAddNewProfileModal: false});

        console.log("Data add new", data);
        if(this.state.cameFromRegister && !data.answer && this.state.transactionSuccess) {
            this.setState({goToDownload: true},()=>
            {
                // Updates the parent (send it owns to state to update it)
                this.props.updateParent(this.state);
                return this.state;
            });
        }
        else if (this.state.transactionSuccess && !this.state.cameFromRegister && !data.answer) {
            this.setState({goToDashboard: true},()=>
            {
                this.props.updateParent(this.state);
                return this.state;
            });
        }
    }

    /**
     * Submit register
     */
    submitRegister() {
        console.log("Submitting");
        console.log(this.state.subscriptionId);
        // Submits the registration
        let apiCall = ApiCalls.registerProfile(this.state.subscriptionId,this.state.username, this.state.password, this.state.passwordRetype,
            this.state.firstName, this.state.lastName, this.state.sex, this.state.dob);

        apiCall.then((returned)=> {
            console.log(returned, "Returned data");
            this.setState({loading: false}, ()=> {
                // Reset fields
                if (returned.TransactionValid) {

                    this.setState({
                        firstName: '',
                        lastName: '',
                        password: '',
                        passwordRetype: '',
                        username: '',
                        dob: null,
                        sex: '',
                        validPassword: false,
                        usernameAvailable: true,
                        validUsername: false,
                        validFirstName: false,
                        validLastName: false,
                        createdAt: moment(),
                        calendarFocused: false,
                        proceedSubmit: false,
                        transactionSuccess: true
                    },()=>{
                        console.log("Returned",returned);
                        // If there is any space left in the subscription, show to add new modal
                        if(returned.SpacesInSubscriptionLeft)
                        {
                            let propsModalAddNew = {
                                visible: true
                            };
                            this.setState(
                                {propsModalAddNewProfile: propsModalAddNew,
                                    showAddNewProfileModal: true,
                                    loading: false});
                        }
                        else
                        {
                            // Show general alert
                            let propsModal = {
                                bodyText: returned.Messages[0],
                                visible: true
                            };
                            this.setState({propsModal: propsModal, showErrorModal: true});
                        }
                    });
                }
                else
                {
                    let propsModal = {
                        bodyText: returned.Messages[0],
                        visible: true
                    };
                    this.setState({propsModal: propsModal, showErrorModal: true});
                }
            });
        });
    }

    /**
     * Sets if submit button is ready or not
     */
    setSubmitButtonState() {

        this.setState({
            proceedSubmit: (
            this.state.validFirstName &&
            this.state.validLastName &&
            this.state.validPassword &&
            this.state.validUsername &&
            this.state.usernameAvailable &&
            this.state.subscriptionId != null && this.state.subscriptionId.length > 0)
        });
    }

    /**
     * Saves the username state and verifies if the next button is ready
     * @param field
     */
    saveUsername = (field) => (newValue) => {
        this.setState({
            'username': newValue.username,
            'validUsername': newValue.validUsername,
            'usernameAvailable': newValue.usernameAvailable
        }, () => {
            this.setSubmitButtonState();
        });
    };

    /**
     * Save the password state and verifies if the next button is ready
     * @param field
     */
    savePassword = (field) => (newValue) => {
        this.setState({
            'password': newValue.password,
            'passwordRetype': newValue.passwordRetype,
            'validPassword': newValue.validPassword
        }, () => {
            this.setSubmitButtonState();
        });
    };

    /**
     * Save the name details and verifies if the next button is ready
     * @param field
     */
    saveName = (field) => (newValue) => {
        this.setState({
            'firstName': newValue.firstName,
            'lastName': newValue.lastName,
            'validFirstName': newValue.validFirstName,
            'validLastName': newValue.validLastName
        }, () => {
            this.setSubmitButtonState();
        });
    };

    /**
     * Saves the sex
     * @param field
     */
    saveSex = (field) => (newValue) => {
        this.setState({'sex': newValue}, ()=> {
            this.setSubmitButtonState();
        });
    };

    /**
     * Saves the DOB
     * @param field
     */
    saveDob = (field) => (newValue)=> {
        this.setState({'dob': newValue.date}, ()=> {
            this.setSubmitButtonState();
        });
    };

    /**
     * Renders the first part of the form
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <Card className="card-white">
                    <CardHeader className="card-cyan">
                        <h4 className="white-text">
                            <Translate id="profile-register.add-new-profile" options={{renderInnerHtml: false}}/>
                        </h4>
                        <small>
                            <Translate id="profile-register.add-new-profile-subtitle"
                                       options={{renderInnerHtml: false}}/>
                        </small>
                    </CardHeader>
                    <CardBody>
                        <Form>
                            <FormGroup row>
                                <Col sm={{size: 10, offset: 1}}>
                                    <Label for="subscription">
                                        <Translate id="profile-register.select-subscription"/>
                                    </Label>
                                </Col>
                                <Col sm={{size: 10, offset: 1}}>
                                    <SelectorSubscriptions data={this.state.subscriptionId} value={this.state.subscriptionId}
                                                           updateParent={this.setSelectedSubscription("subscription")}/>
                                </Col>
                            </FormGroup>
                            <FormGroupUsername data={this.state} updateParent={this.saveUsername()}/>
                            <FormGroupNewPassword data={this.state} updateParent={this.savePassword()}/>
                            <FormGroupName data={this.state} updateParent={this.saveName()}/>
                            <FormGroup row>
                                <Col sm={{size: 10, offset: 1}}>
                                    <Label for="sex">
                                        <Translate id="profile-register.sex"/>
                                    </Label>
                                    <SelectorSex data={this.state} updateParent={this.saveSex()}/>
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Col sm={{size: 10, offset: 1}}>
                                    <Label for="dob">
                                        <Translate id="profile-register.dob"/>
                                    </Label>
                                    <DatePicker data={this.state} updateParent={this.saveDob()}/>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{size: 10, offset: 1}}>
                                    <Button color="success" block disabled={!this.state.proceedSubmit}
                                            onClick={this.submitRegister}>
                                        <Translate id="profile-register.add-new-profile-btn"
                                                   options={{renderInnerHtml: false}}/>
                                    </Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </CardBody>
                </Card>
                {this.state.showErrorModal ? <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}
                {this.state.showAddNewProfileModal ? <ModalAddAnotherProfile data={this.state.propsModalAddNewProfile} updateParent={this.toogleAlertAddNewProfile} />  : null}
            </div>
        )
    };
}

export default withLocalize(FormProfileRegister);


// WEBPACK FOOTER //
// ./src/components/forms/form-profile-register.js